import { Chrome } from 'vue-color'
import { VueConstructor } from 'vue/types/umd'

/**
 * Helper function to install the plugin Vue Color.
 * @param Vue
 */
export function installVueColor(Vue: VueConstructor): void {
  Vue.component('ColorPicker', Chrome)
}
